export function patientPath(institutionId, relationshipId = "") {
  const suffix = relationshipId ? `/${encodeURIComponent(String(relationshipId))}` : "";
  return `/institutions/patients${suffix}?institution=${encodeURIComponent(String(institutionId || ""))}`;
}

export function formatPatientStatus(value) {
  return String(value || "not_recorded").replaceAll("_", " ").replace(/\b\w/g, (letter) => letter.toUpperCase());
}
